class ParallaxGallery extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._raf = null;
  }

  connectedCallback() {
    this.stage = this.closest(".parallax-gallery__stage");
    this.items = Array.from(this.querySelectorAll(".parallax-gallery__item"));
    this.enableParallax = this.dataset.enableParallax !== "false";

    if (!this.stage || !this.items.length || !this.enableParallax) return;

    window.addEventListener("scroll", this._onScroll, { passive: true });
    window.addEventListener("resize", this._onScroll, { passive: true });

    this._onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this._onScroll);
    window.removeEventListener("resize", this._onScroll);

    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
  }

  _onScroll() {
    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }

    this._raf = requestAnimationFrame(() => {
      const rect = this.stage.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.bottom < 0 || rect.top > windowHeight) return;

      const total = rect.height - windowHeight;
      const current = Math.min(Math.max(-rect.top, 0), total);
      const progress = total > 0 ? current / total : 0;

      this.items.forEach((item, index) => {
        const offset = Number(item.dataset.offset) || 80;

        /*
          Left/right alternating movement.
          This creates the Muraqqa-style floating scroll.
        */
        const direction = index % 2 === 0 ? -1 : 1;
        const movement = (progress - 0.5) * offset * 4 * direction;

        item.style.transform = `translate3d(0, ${movement}px, 0)`;
      });
    });
  }
}

if (!customElements.get("parallax-gallery")) {
  customElements.define("parallax-gallery", ParallaxGallery);
}